// namespace
export const CEREMONY_NAMESPACE = 'ceremony'

// getters
export const CEREMONY_GETTER = 'ceremony'

// mutations
export const CEREMONY_MUTATION_SINGLE_ENTRY = 'updateCeremonyFromSingleEntry'
export const CEREMONY_MUTATION_ENTIRE_CEREMONY = 'updateEntireCeremony'
export const CEREMONY_MUTATION_ADD_CEREMONY_MUSICS = 'addCeremonyMusics'

// actions
export const CEREMONY_ACTION_GET_CEREMONY = 'fetchCeremony'
export const CEREMONY_ACTION_SAVE_CEREMONY = 'saveCeremony'



// WEBPACK FOOTER //
// ./src/store/modules/ceremony-types.js